<template>
  <div>
    <div class="flex flex-row h-full">
      <div id="decor_facets"
           :class="{'w-1/2 lg:w-2/5 1.5xl:w-1/4 4k:w-1/5': opened, 'w-1/30':!opened}">
        <c-packages-facets
          v-if="facetsLoaded"
          class="overflow-y-auto h-full"
          @reload-facets="resetFacets"
          :facets="facets"
          :query-data="queryObject"
          :opened.sync="opened"
          :only-new.sync="onlyNew"
          :only-top.sync="onlyTop"
          :active-tab.sync="activeTab"
          :numbers.sync="numbers"
        />
      </div>
      <div id="decors"
           :class="{'h-19/20 w-1/2 lg:w-3/5 1.5xl:w-3/4 pl-10 pr-10 1.5xl:pl-10 1.5xl:pr-20 4k:w-4/5': opened, 'w-29/30 px-2':!opened}">
        <c-box-display
          v-if="activeTab===0 && isLoaded"
          class="overflow-y-auto h-full pb-5"
          :filter-open="opened"
          :boxes="objects"
          :hasMore="links.next !== null && meta.total !== 0"
          @load-more="fetchNextPackages"
        />
        <c-inlay-display
          v-if="activeTab===1 && isLoaded"
          class="overflow-y-auto h-full pb-5"
          :filter-open="opened"
          :hasMore="links.next !== null && meta.total !== 0"
          :inlays="objects"
          @load-more="fetchNextPackages"
        />
        <div class="flex align-middle h-17/20" v-if="!isLoaded">
          <c-loader :inline="true"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from "debounce";
import getTranslation from "../../../mixins/getTranslation";
import PackagesFacets from "./PackagesFacets";
import BoxesDisplay from "./boxes/BoxesDisplay";
import InlayDisplay from "./inlays/InlayDisplay";
import Loader from "../../Loader";

export default {
  name: 'Packaging',

  mixins: [getTranslation],

  components: {
    'c-packages-facets': PackagesFacets,
    'c-box-display': BoxesDisplay,
    'c-loader': Loader,
    'c-inlay-display': InlayDisplay,
  },

  computed: {
    getType() {
      return this.activeTab === 1 ? 'inlay' : 'box';
    }
  },

  watch: {
    getType() {
      this.queryObject.query.type = this.getType;
      this.queryObject.query.inlayId = null;
      this.queryObject.query.boxId = null;
      this.queryObject.query.name = null;
      this.queryObject.query.articleNumbers = [];
      this.fetchPackaging();
    },

    "queryObject.query.articleNumbers": debounce(function () {
      this.fetchPackaging();
    }, 500),

    "queryObject.query.boxId": debounce(function () {
      this.fetchPackaging();
    }, 500),

    "queryObject.query.inlayId": debounce(function () {
      this.fetchPackaging();
    }, 500),

    "queryObject.query.name": debounce(function () {
      this.fetchPackaging();
    }, 500),

    numbers() {
      if (!this.numbers) {
        this.queryObject.query.articleNumbers = [];
        return;
      }
      let numbersArray = this.numbers.replace(/ /g, '').split(',');
      this.queryObject.query.articleNumbers = numbersArray;
    }
  },

  data() {
    return {
      facetsLoaded: true,
      activeTab: 0,
      objects: [],
      page: 1,
      size: 48,
      meta: [],
      links: [],
      opened: true,
      onlyNew: false,
      onlyTop: false,
      isLoaded: false,
      isFetching: false,
      facets: {},
      numbers: '',
      queryObject: {
        query: {
          boxId: null,
          inlayId: null,
          name: null,
          articleNumbers: [],
          type: 'box',
        },
        sort: {},
        language: "en"
      },
    }
  },

  created() {
    this.fetchPackaging();
  },

  methods: {
    fetchNextPackages() {
      this.page++;
      const data = {page: this.page, size: this.size, queryData: this.queryObject}
      this.$dashboardStore.dispatch('searchPackages', data)
        .then((response) => {
          this.objects = [...this.objects, ...response.data];
          this.meta = response.meta;
          this.links = response.links;
        });
    },

    async fetchPackaging() {
      if (this.isFetching) {
        return
      }

      this.isFetching = true;
      this.isLoaded = false
      this.page = 1;
      const data = {page: this.page, size: this.size, queryData: this.queryObject}
      const response = await this.$dashboardStore.dispatch('searchPackages', data)
      this.isLoaded = true;
      this.objects = response.data;
      this.meta = response.meta;
      this.links = response.links;
      this.isFetching = false;
    },

    resetFacets() {
      this.numbers = '';
      this.$set(
        this.queryObject,
        'query',
        {
          boxId: null,
          inlayId: null,
          name: null,
          articleNumbers: [],
          type: this.getType,
        }
      )

      this.facetsLoaded = false;
      this.$nextTick(() => {
        this.facetsLoaded = true
      })
    }
  }
};
</script>
